// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federkennzeichnung/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federkennzeichnungDE: PageEntry = {
  id: "post.federkennzeichnung",
  locale: "de",
  slug: "federkennzeichnung",
  seo: {
    title: "Glossar: Federkennzeichnung einfach erklärt | Dietz GmbH",
    description: "Die Federkennzeichnung beinhaltet die Markierung oder Kennzeichnung von Federn, um Informationen über ihre Spezifikationen, Herkunft oder Einsatzbereiche bereitzustellen. Typische ",
  },
  type: "post",
  h1: "Glossar: Federkennzeichnung einfach erklärt",
  intro: "Die Federkennzeichnung beinhaltet die Markierung oder Kennzeichnung von Federn, um Informationen über ihre Spezifikationen, Herkunft oder Einsatzbereiche bereitzustellen. Typische Kennzeichnungen können Angaben zur Federkonstante, Materialart, Herstellungsdatum oder Herstellerinformationen umfassen. Die Federkennzeichnung ist wichtig für die Identifikation und Verfolgung von Federn während ihres Lebenszyklus. Dies erleichtert Wartungsarbeiten, Qualitätskontrolle und die Einhaltung von Standards. Klare und präzise Kennzeichnungen sind somit entscheidend, um die richtige Verwendung und Handhabung von Federn in verschiedenen Anwendungen zu gewährleisten.",
  blocks: [

  ],
};
